export interface DocumentTemplateSolutionInterface {
  id: string;
  documentTemplateId: string;
  ownerId: string;
  ownerType: string;
  status: string;
  snapshot?: any;
  createdAt: string;
  updatedAt: string;
  documentTemplate?: {
    id: string;
    name: string;
  };
}

export class DocumentTemplateSolution implements DocumentTemplateSolutionInterface {
  id: string;
  documentTemplateId: string;
  ownerId: string;
  ownerType: string;
  status: string;
  snapshot?: any;
  createdAt: string;
  updatedAt: string;
  documentTemplate?: {
    id: string;
    name: string;
  };

  constructor(data: Partial<DocumentTemplateSolutionInterface>) {
    this.id = data.id!;
    this.documentTemplateId = data.documentTemplateId!;
    this.ownerId = data.ownerId!;
    this.ownerType = data.ownerType!;
    this.status = data.status!;
    this.snapshot = data.snapshot;
    this.createdAt = data.createdAt!;
    this.updatedAt = data.updatedAt!;
    this.documentTemplate = data.documentTemplate;
  }

  toJson(): DocumentTemplateSolutionInterface {
    return {
      id: this.id,
      documentTemplateId: this.documentTemplateId,
      ownerId: this.ownerId,
      ownerType: this.ownerType,
      status: this.status,
      snapshot: this.snapshot,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      documentTemplate: this.documentTemplate,
    };
  }
}